import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { syncFromCookie, consumeUrlToken } from "./utils/crossDomainAuth";
import { ThemeToggle } from "./features/dark-mode";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminRoute } from "./components/AdminRoute";
import { LoginPage, SignupPage, ResetPasswordPage, ChangePasswordPage } from "./features/auth";
import { DashboardPage } from "./features/dashboard";
import { CreateListingPage, EditListingPage, ListingsPage, ListingDetailPage, BrokerBulkPage, OwnerListings } from "./features/listings";
import { NdaAgreementPage } from "./features/nda";
import { AdminPage, BulkUploadPage } from "./features/admin";
import { LandingPage } from "./features/landing";
import { MyPage } from "./features/mypage";
import { OwnerListingCreate } from "./features/owner/OwnerListingCreate";
import { OwnerLoginPage } from "./features/owner/OwnerLoginPage";
import { OwnerMyPage } from "./features/owner/OwnerMyPage";
import { AgentProfilePage } from "./features/agents/AgentProfilePage";
import { BurialSearchPage } from "./features/burial/BurialSearchPage";
import { NotFoundPage } from "./features/errors/NotFoundPage";
import { PrivacyPage } from "./features/legal/PrivacyPage";
import { TermsPage } from "./features/legal/TermsPage";
import LiveBroadcastPage from "./features/live-tour/LiveBroadcastPage";
import LiveViewPage from "./features/live-tour/LiveViewPage";
import VideoConsultPage from "./features/video-consult/VideoConsultPage";

function App() {
  useEffect(() => {
    syncFromCookie();
    consumeUrlToken();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listings/new"
          element={
            <ProtectedRoute>
              <CreateListingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listings/bulk-upload"
          element={
            <ProtectedRoute>
              <BrokerBulkPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listings/:id/edit"
          element={
            <ProtectedRoute>
              <EditListingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/bulk-upload"
          element={
            <AdminRoute>
              <BulkUploadPage />
            </AdminRoute>
          }
        />
        <Route
          path="/mypage"
          element={
            <ProtectedRoute>
              <MyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nda"
          element={
            <ProtectedRoute>
              <NdaAgreementPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<LandingPage />} />
        <Route path="/listings" element={<ListingsPage />} />
        <Route path="/listings/:id" element={<ListingDetailPage />} />
        {/* Phase 6: 라이브 투어 + 화상 상담 */}
        <Route
          path="/listings/:id/broadcast"
          element={
            <ProtectedRoute>
              <LiveBroadcastPage />
            </ProtectedRoute>
          }
        />
        <Route path="/listings/:id/live" element={<LiveViewPage />} />
        <Route path="/consult/:consultId" element={<VideoConsultPage />} />
        {/* owner / agent / burial */}
        <Route
          path="/owner-listings"
          element={
            <ProtectedRoute>
              <OwnerListings />
            </ProtectedRoute>
          }
        />
        <Route path="/owner/login" element={<OwnerLoginPage />} />
        <Route path="/owner/register" element={<OwnerListingCreate />} />
        <Route path="/owner/mypage" element={<OwnerMyPage />} />
        <Route path="/agent/:agentId" element={<AgentProfilePage />} />
        <Route path="/burial" element={<BurialSearchPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ThemeToggle />
    </BrowserRouter>
  );
}

export default App;
